"use client";
/***
 *
 * @file components/InstagramEmbed/index.tsx
 * @description InstagramEmbed component will be used for rendering the content.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 15 Jul 2025
 *
 */

import { Suspense } from "react";
import dynamic from "next/dynamic";

const Spinner = dynamic(() => import("../Spinner"), { ssr: false });
const Instagram = dynamic(() => import("./Instagram"), {
    ssr: false,
    loading: () => <Spinner />
});

type Props = {
    url: string;
    showCaption?: boolean;
};

const InstagramEmbed = ({ url, showCaption = false }: Props) => {
    return (
        <Suspense fallback={<Spinner />}>
            <Instagram url={url} showCaption={showCaption} />
        </Suspense>
    );
};

export default InstagramEmbed;